import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { QueryConfig, QueryConfigPickRes } from '../../reactQuery';
import { CommuteProfileProcessed, fetchCommuteProfile, fetchCommuteProfiles } from './api';
export const useAccountCommuteProfiles = (accountId, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== accountId) {
    t0 = ["commute-profiles", accountId];
    t1 = async () => {
      if (!accountId) {
        throw new Error("cannot call fetchCommuteProfiles with accountId undefined");
      }
      const {
        records
      } = await fetchCommuteProfiles({
        accountId,
        relations: ["commuteCosts", "vehicles"]
      });
      return records;
    };
    $[0] = accountId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      gcTime: 0
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
export const useAccountCommuteProfile = (commuteProfileId, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== commuteProfileId) {
    t0 = ["commute-profiles", commuteProfileId];
    t1 = async () => {
      if (!commuteProfileId) {
        throw new Error("cannot call fetchCommuteProfiles with commuteProfileId undefined");
      }
      return fetchCommuteProfile(commuteProfileId, {
        relations: ["commuteCosts", "vehicles"]
      });
    };
    $[0] = commuteProfileId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};